var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.type === 'discount')?_c('div',{class:[
    {
      'show-case-finished': _vm.isShowCaseFinished,
      animation: _vm.isShowCaseFinished,
    },
    'show-case-discount-card',
  ],on:{"click":_vm.openUrl}},[_c('Icon',{class:[{ 'show-case-finished--icon': _vm.isShowCaseFinished }],attrs:{"name":_vm.isShowCaseFinished ? 'unlock' : _vm.icon}}),_c('span',{class:[
      { 'show-case-finished--title': _vm.isShowCaseFinished },
      'show-case-discount-card--title',
    ]},[_vm._v(" "+_vm._s(_vm.isShowCaseFinished ? _vm.$t('trial.showCase.discountCardUnlockedTitle') : _vm.title)+" ")]),_c('hr',{style:({ background: _vm.bottomBarColor })})],1):_c('div',{class:[{ completed: _vm.isCompleted }, 'show-case-card'],on:{"click":_vm.openUrl}},[_c('Icon',{class:[{ 'completed--icon': _vm.isCompleted }],attrs:{"name":_vm.isCompleted ? 'checkCircle' : _vm.icon}}),_c('span',{staticClass:"show-case-card--title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('hr',{style:({ background: _vm.bottomBarColor })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }